import './SectionItem.scss';

export { default } from './SectionItem';
